import { create, node } from '@dojo/framework/core/vdom';
const factory = create({ node });
export const scroll = factory(({ middleware: { node } }) => {
    return {
        scrollIntoView(key) {
            const domNode = node.get(key);
            if (!domNode) {
                return false;
            }
            domNode.scrollIntoView(true);
            return true;
        },
        scrollTo(key, options) {
            const domNode = node.get(key);
            if (!domNode) {
                return false;
            }
            domNode.scrollTo(options);
            return true;
        }
    };
});
